import { Theme, css } from '@emotion/react';

export const titleBox = (theme: Theme, publicPage?: boolean) => css`
  background-color: ${theme.colors.bgLight};
  border-bottom: 1px solid ${theme.colors.borderDefault};
  margin-top: ${theme.spacing(-3)}px;
  padding-top: ${theme.spacing(3)}px;
  padding-bottom: ${theme.spacing(3)}px;

  ${theme.breakpoints.up('sm')} {
    background-color: ${theme.colors.bgDefault};
  }

  ${publicPage ? titleBoxRoot(theme) : titleBoxProfile(theme)}
`;

const titleBoxRoot = ({ breakpoints, spacing }: Theme) => css`
  ${breakpoints.up('sm')} {
    margin-top: ${spacing(-4)}px;
    padding-top: ${spacing(4)}px;
    padding-bottom: ${spacing(4)}px;
  }

  ${breakpoints.up('md')} {
    padding-top: ${spacing(8)}px;
    padding-bottom: ${spacing(8)}px;
  }
`;

const titleBoxProfile = ({ breakpoints, spacing }: Theme) => css`
  margin-top: 0;
  border-bottom-width: 0;
  padding-bottom: ${spacing(3)}px;
  padding-top: ${spacing(3)}px;

  ${breakpoints.down('sm')} {
    margin-top: ${spacing(-3)}px;
    margin-left: ${spacing(-3)}px;
    margin-right: ${spacing(-3)}px;
  }
`;

export const gridList = ({ breakpoints, spacing }: Theme) => css`
  padding-bottom: ${spacing(3)}px;
  padding-top: ${spacing(3)}px;

  ${breakpoints.up('md')} {
    padding-bottom: ${spacing(7)}px;
    padding-top: ${spacing(7)}px;
  }
`;

export const gridListProfile = ({ spacing }: Theme) => css`
  padding-bottom: ${spacing(3)}px;
  padding-top: ${spacing(3)}px;
`;

export const justRemovedBox = ({ colors, spacing }: Theme) => css`
  background-color: ${colors.bgDefault};
  padding: ${spacing(2)}px;
  display: flex;
  align-items: center;
`;

export const businessNameRemoved = ({ colors }: Theme) => css`
  color: ${colors.fgPrimaryBase};
  text-decoration: none;
`;

export const readdButton = ({ spacing }: Theme) => css`
  margin-right: ${spacing(1)}px;
`;

export const mobileDivider = ({ breakpoints }: Theme) => css`
  ${breakpoints.up('sm')} {
    display: none;
  }
`;
